import { axiosV3 } from "../../../Utils/Axios/axiosV3";
export const buyTeachingItemService = async (
  userToken: string,
  teachItemId: string | number,
  payWithWallet:number,
  payWithGiftWallet:number,
) => {
  const data = new FormData();
  data.append("section_id", String(teachItemId));
  data.append("pay_with_wallet", String(payWithWallet));
  data.append("pay_with_gift_wallet", String(payWithGiftWallet));
  return axiosV3.post("buy_section", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
